import { Box, Typography } from '@mui/material';
import { AntSwitch, toLowerCase } from '../../../../constants/commonFunction';
import { BLUE, COMMON, GREY } from '../../../../constants/style';
import {
  getIconForVendor,
  IinventotyProps,
} from '../../../../pages/RewardLoyalty/components/BenefitsInventory';
import { ICreateInventoryProps } from '../../../../types/RewardsLoyalty';
import { IVoucherColumn } from '../../GiftVoucher/components/ListOfGiftVoucher';

export const DEFAULT_DATA = [
  {
    id: '#81727812718',
    vendor: 'Amazon',
    plan: '1 year',
    quantity: 50,
    totaValue: 250000,
    assigned: 10,
    remaining: 40,
    autoRenew: true,
  },
  {
    id: '#81727812718',
    vendor: 'Freecharge ',
    plan: '1 year',
    quantity: 50,
    totaValue: 250000,
    assigned: 10,
    remaining: 40,
    autoRenew: false,
  },
];

const COLUMN: IVoucherColumn[] = [
  {
    key: 'vendorName',
    header: 'Marchants',
    flex: 1,
  },
  {
    key: 'plan',
    header: 'Plan',
    flex: 0.5,
  },
  {
    key: 'quantity',
    header: 'Quantity',
    flex: 0.5,
  },

  {
    key: 'totalValue',
    header: 'Total value',
    flex: 0.5,
  },
  {
    key: 'assigned',
    header: 'Assigned',
    flex: 0.5,
  },
  {
    key: 'remaining',
    header: 'Remaining',
    flex: 0.5,
  },
  {
    key: 'autoRenew',
    header: 'Auto Renew',
    flex: 0.5,
  },
];

interface IProps {
  data: ICreateInventoryProps[];
  updateRenewInventory: (id: string | undefined, renew: boolean) => void;
}

const ListOfSubscription = ({ data, updateRenewInventory }: IProps) => {
  return (
    <Box sx={{ px: 2 }}>
      <Box
        sx={{
          display: 'flex',

          //   bgcolor: GREY.light,
        }}
      >
        {COLUMN.map((column: IVoucherColumn) => (
          <Box
            className="font-aspekta-500"
            sx={{
              flex: column.flex,
              py: 2,
              px: 2,
              fontSize: 13,
              color: COMMON.gray,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {toLowerCase(column.header)}
          </Box>
        ))}
      </Box>

      {data.map((voucher: ICreateInventoryProps) => (
        <Box
          sx={{
            display: 'flex',
            bgcolor: '#F7F7F7',
            my: 1.5,
            borderRadius: '15px',
            cursor: 'pointer',
          }}
          //   onClick={() => selectCampaign(voucher)}
        >
          {COLUMN.map((column: IVoucherColumn) => {
            // const kycURL = getURL(value.kycUrl);

            return (
              <>
                <Box
                  sx={{
                    flex: column.flex,
                    py: 1.5,
                    px: 2,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {column.key === 'autoRenew' ? (
                    <Box>
                      <AntSwitch
                        sx={{ mx: 1 }}
                        checked={voucher.autoRenew}
                        onChange={(e) =>
                          updateRenewInventory(voucher?.id, e.target.checked)
                        }
                      />
                    </Box>
                  ) : column.key === 'vendorName' ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {getIconForVendor(voucher[column.key])}
                      <Typography
                        fontSize={14}
                        ml={1}
                        className="font-aspekta-500"
                      >
                        {toLowerCase(voucher[column.key])}
                      </Typography>
                    </Box>
                  ) : column.key === 'plan' ? (
                    <Typography fontSize={14} className="font-aspekta-500">
                      {voucher.subscribtion?.number}
                      {'   '}
                      {getTimeframeDisplayText(
                        voucher.subscribtion?.timeframe ?? ''
                      )}
                    </Typography>
                  ) : (
                    <Typography fontSize={14} className="font-aspekta-500">
                      {toLowerCase(voucher[column.key])}
                    </Typography>
                  )}

                  {column.key === 'action' && (
                    <Typography fontSize={14} className="font-aspekta-500">
                      action
                    </Typography>
                  )}
                </Box>
              </>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

export default ListOfSubscription;

const getTimeframeDisplayText = (type: string) => {
  switch (type) {
    case 'MONTHLY':
      return 'Month(s)';
    case 'ANNUALLY':
      return 'Year(s)';
    case 'QUARTERLY':
      return 'Quarter(s)';
  }
  return '';
};
